<template>
  <div class="detail-page">
    <div class="detail-page__title">
      <div class="page-nav-wrapper">
        <span class="page-nav__item">
          <router-link to="/index" class="page-nav__item-a">首页</router-link>
          /
        </span>
        <span class="page-nav__item">
          <router-link to="/hudong" class="page-nav__item-a">
            互动交流
          </router-link>
          /
        </span>
        <!-- <span class="page-nav__item">
          <span class="page-nav__item-a"> 咨询答复 </span>
          <template> / </template>
        </span> -->
        <span class="page-nav__item">
          <span class="page-nav__item-a"> 答复详情 </span>
        </span>
      </div>
    </div>

    <div class="detail-article">
      <div class="con">
        <p>咨询标题：{{ model.title }}</p>
        <p>咨询时间：{{ model.createtime | dayjs("year-date") }}</p>
        <div>
          <p>
            咨询内容：
          </p>
          <p v-html="model.content" style="flex: 1;text-indent: 0;"></p>
        </div>
        <p></p>
        <p>回复单位：{{ model.hf_dw }}</p>
        <p>回复时间：{{ model.hf_time | dayjs("year-date") }}</p>
        <!-- <p>回复内容：{{ model.hf_content }}</p> -->
        <div>
          <p>
            回复内容：
          </p>
          <p style="flex: 1;text-indent: 0;" v-html="model.hf_content"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getZixundafuOne as getOne } from "../../apis/hudong";

export default {
  data() {
    return {
      model: {},
    };
  },
  created() {
    this.getOne(this.$route.query.id);
  },
  methods: {
    async getOne(id) {
      const { data } = await getOne({ id: id });
      this.model = data;
    },
  },
  computed: {
    matched() {
      return this.$route.matched;
    },
  },
};
</script>

<style lang="scss" scoped>
.con {

  // ::v-deep p {
  p {
    text-indent: 2em;
    font-size: 18px;
    font-size: var(--font-size-18);
    font-weight: 500;
    line-height: 44px;
    color: #303133;
  }
}
</style>